import { render, staticRenderFns } from "./ElementPrizeComp.vue?vue&type=template&id=50009cf7&"
import script from "./ElementPrizeComp.vue?vue&type=script&lang=js&"
export * from "./ElementPrizeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports